import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
} from "@mui/material";
import { useGoogleMaps } from "../../../../../../utils/mapConfig";
import { Autocomplete } from "@react-google-maps/api";

const UserForm = ({ open, onClose, user, onSubmit }) => {

  const { isLoaded } = useGoogleMaps();
  const autocompleteRef = useRef(null);
  
  const [formState, setFormState] = useState({
    name: "",
    phone: "",
    location: "",
    address: "",
  });

  useEffect(() => {
    if (user) {
      setFormState({
        name: user.name,
        phone: user.phone,
        location: user.location,
        address: user.address,
      });
    } else {
      setFormState({
        name: "",
        phone: "",
        address: "",
        location: "",
      });
    }
    setErrors({});
  }, [user, open]);

  const [errors, setErrors] = useState({});

  const validationForm = () => {
    const newErrors = {};
    if (!formState.name) newErrors.name = "User Name is required";

    if (!formState.phone) {
      newErrors.phone = "Mobile number is required.";
    } else if (!/^\d{10}$/.test(formState.phone)) {
      newErrors.phone = "Mobile number must be 10 digits.";
    }

    if (!formState.address) newErrors.address = "Address is required";
    if (!formState.location) newErrors.location = "Location is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validationForm()) {
      onSubmit(formState);
      onClose();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };
  const handlePlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      if (place && place.formatted_address) {
        setFormState((prevState) => ({
          ...prevState,
          location: place.formatted_address,
        }));
      }
    }
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle style={{ color: "#ff4d4d" }}>
        {user ? "Edit User Details" : "Add User Details"}
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="User Name"
          name="name"
          value={formState.name}
          onChange={handleChange}
          error={!!errors.name}
          helperText={errors.name}
          margin="dense"
        />
        <TextField
          fullWidth
          label="Phone"
          name="phone"
          value={formState.phone}
          onChange={handleChange}
          error={!!errors.phone}
          helperText={errors.phone}
          margin="dense"
        />
        {isLoaded && (
          <Autocomplete
            onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
            onPlaceChanged={handlePlaceChanged}
          >
            <TextField
              fullWidth
              label="location"
              name="location"
              value={formState.location}
              onChange={handleChange}
              error={!!errors.location}
              helperText={errors.location}
              margin="dense"
            />
          </Autocomplete>
        )}
        <TextField
          fullWidth
          label="Address"
          name="address"
          value={formState.address}
          onChange={handleChange}
          error={!!errors.address}
          helperText={errors.address}
          margin="dense"
          multiline
          rows={4}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          color="error"
          style={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="success"
          style={{ textTransform: "none" }}
        >
          {user ? "Edit" : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserForm;
